<template>
  <van-tabs v-model="active" :before-change="beforeChange" :color="color">
    <van-tab v-for="(tabitem, index) in titles" :key="titles[index]" :title="tabitem" >
      <div v-for="item in detailResponses" :key="item.linkedId">
        <div class="schedule-list">
          <div class="list-header">
            <span class="business-type">业务类型：{{item.serviceName}}</span>
            <span v-if="item.stepCode === '1'" class="ab-right green">已完成</span>
            <span v-else-if="item.stepCode === '6'" class="ab-right red">已挂起</span>
            <span v-else class="ab-right orange">待处理</span>
          </div>
          <div class="list-content">
            <div class="con">
              <span class="con-title">申请时间：</span>
              <span class="con-status">{{item.createTime}}</span>
            </div>
            <div class="con">
              <span class="con-title">业务步骤：</span>
              <span class="con-status">{{item.stepName}}</span>
            </div>
            <div class="con">
              <span class="con-title">业务状态：</span>
              <span class="con-status">{{item.stepStatus}}</span>
            </div>
            <div v-if="item.stepRemark != ''" class="con">
              <span class="con-title">业务说明：</span>
              <span class="con-status">{{item.stepRemark}}</span>
            </div>
          </div>
          <div class="list-bottom">
            <button class="detail-msg" @click="goBusMsg(item)">业务进度</button>
            <button class="detail-bottom" @click="goBusDetail(item)">业务详情</button>
          </div>
        </div>
      </div>
    </van-tab>
  </van-tabs>
</template>
<script>
import Vue from 'vue'
import { Notify, Tab, Tabs, Button } from 'vant'
// import { getScheduleListReq, getBizTokenReq, getEyeInfoReq } from '@/api/manage'
import { getScheduleListReq, getBizTokenReq } from '@/api/manage'

Vue.use(Tab)
Vue.use(Tabs)
Vue.use(Button)
export default {
  data () {
    return {
      active: 0,
      color: '#008ACB',
      titles: [
        '全部业务',
        '已完成',
        '待处理'
      ],
      detailResponses: {}
    }
  },
  mounted () {
    if (this.$route.params.index != null) {
      this.active = this.$route.params.index
      localStorage.setItem('listIndex', this.active)
    } else if (localStorage.getItem('listIndex') != null) {
      this.active = parseInt(localStorage.getItem('listIndex'))
    } else {
      this.active = 0
      localStorage.setItem('listIndex', this.active)
    }
    this.getScheduleList()
  },
  methods: {
    beforeChange (index) {
      this.active = index
      localStorage.setItem('listIndex', this.active)
      this.getScheduleList()
      return true
    },
    getScheduleList () {
      const params = {
        token: this.$cookies.get('token'),
        openId: this.$cookies.get('openid'),
        type: this.active
      }
      getScheduleListReq(params).then(response => {
        const res = response.data
        console.log(res)
        if (res.code === 200) {
          this.detailResponses = res.data
        }
      })
        .catch((res) => {
          Notify({ type: 'danger', message: '获取业务列表失败' })
        })
    },
    goBusMsg (obj) {
      this.$router.push({
        name: 'rateOfAdv',
        query: {
          token: this.$cookies.get('token'),
          linkedId: obj.linkedId
        }
      })
    },
    goBusDetail (obj) {
      console.log(obj)
      if (obj.stepCode === '6') {
        Notify({ type: 'danger', message: '当前业务已挂起，无法继续办理' })
      } else if (obj.stepName === '人脸识别') {
        const params = {
          token: this.$cookies.get('token'),
          linkedId: obj.linkedId
        }
        getBizTokenReq(params).then(response => {
          const res = response.data
          if (res.code === 200) {
            const bizData = JSON.parse(res.data)
            console.log(bizData)
            window.location.href = bizData.Url
          } else {
            Notify({ type: 'danger', message: res.message })
          }
        })
          .catch((res) => {
            Notify({ type: 'danger', message: '获取BizToken失败' })
          })
      } else {
        this.$router.push({
          path: obj.localPage,
          query: {
            token: this.$cookies.get('token'),
            linkedId: obj.linkedId
          }
        })
      }
    }
  }
}
</script>

<style lang="less" scoped>
  .schedule-list:first-child {
    margin-top: 10px;
  }
  .schedule-list {
    background: #FFF;
    margin-bottom: 10px;
  }
  .list-header {
    position: relative;
    padding: 12px;
    font-size: 14px;
  }
  .list-content {
    border-top: 1px solid #eee;
    border-bottom: 1px solid #eee;
    font-size: 13px;
  }
  .list-content .con:first-child {
    padding-top: 12px;
  }
  .list-content .con {
    padding: 0 12px 12px 12px;
  }
  .business-type {
    font-weight: bold;
  }
  .ab-right {
    position: absolute;
    top: 10px;
    right: 10px;
  }
  .green {
    color: green;
  }
  .orange {
    color: orange;
  }
  .red {
    color: red;
  }
  .list-bottom {
    position: relative;
    height: 40px;
  }
  .list-bottom .detail-msg {
    position: absolute;
    top: 6px;
    right: 80px;
    font-size: 11px;
    padding: 5px;
    color: #707070;
    border: 1px solid #707070;
    border-radius: 5px;
    background: #FFF;
  }
  .list-bottom .detail-bottom {
    position: absolute;
    top: 6px;
    right: 9px;
    font-size: 11px;
    padding: 5px;
    color: #707070;
    border: 1px solid #707070;
    border-radius: 5px;
    background: #FFF;
  }
</style>
